import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const CreateCoupenMulti = () => {
    const { t } = useTranslation()
    const { user } = useAuth();
    const [msg, setMsg] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [form, setForm] = useState({
        howmanycoupencreate: "",
        coupendescriptionmulti: "",
        expiryDatemulti: "",
        coupenpercentagemulti: "",
        coupenusagelimitmulti: ""
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setForm((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setMsg("");

        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/Cupon/CreateBulk?number=` + form.howmanycoupencreate;
            const res = await axios({
                method: 'Post',
                url: url,
                data: {
                    expiryDate: form.expiryDatemulti,
                    percentage: Number(form.coupenpercentagemulti),
                    usageLimit: Number(form.coupenusagelimitmulti),
                    cuponDescription: form.coupendescriptionmulti
                },
                headers: headerss
            });

            if (res.status === 200 && res.data['success']) {
                await Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: `Tamam`
                });
                setForm({ howmanycoupencreate: "", coupendescriptionmulti: "", expiryDatemulti: "", coupenpercentagemulti: "", coupenusagelimitmulti: "" });
            } else {
                setMsg(res.data['message'] || "Beklenmedik bir hata oluştu.");
            }
        } catch (err) {
            setMsg(err?.message || "Beklenmedik bir hata oluştu.");
        }
        setSubmitting(false);
    }

    return (
        <div className="container-fluid py-3 py-md-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-8 col-xl-6">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-3 p-md-4">
                            <div className="text-center mb-4">
                                <h1 className="h3 mb-1">{t('createmultiplecode')}</h1>
                                <p className="text-muted mb-0">Aynı özelliklere sahip birden fazla kupon kodunu tek seferde oluşturun.</p>
                            </div>

                            {msg ? <div className="alert alert-danger">{msg}</div> : null}

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="howmanycoupencreate">{t("howmanycoupencreate")}</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="howmanycoupencreate"
                                        value={form.howmanycoupencreate}
                                        onChange={handleChange}
                                        min="1"
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="coupendescriptionmulti" className="form-label">{t("coupendescription")}</label>
                                    <textarea
                                        className="form-control"
                                        id="coupendescriptionmulti"
                                        value={form.coupendescriptionmulti}
                                        onChange={handleChange}
                                        rows={3}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label" htmlFor="expiryDatemulti">{t("coupenexpiryDate")}</label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        id="expiryDatemulti"
                                        value={form.expiryDatemulti}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <label className="form-label" htmlFor="coupenpercentagemulti">{t("coupenpercentage")}</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="coupenpercentagemulti"
                                            value={form.coupenpercentagemulti}
                                            onChange={handleChange}
                                            min="0"
                                            max="100"
                                            required
                                        />
                                    </div>

                                    <div className="col-12 col-md-6 mb-3">
                                        <label className="form-label" htmlFor="coupenusagelimitmulti">{t("coupenusagelimit")}</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="coupenusagelimitmulti"
                                            value={form.coupenusagelimitmulti}
                                            onChange={handleChange}
                                            min="1"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="d-grid d-md-flex justify-content-md-center mt-4">
                                    <button type="submit" className="btn btn-primary btn-lg px-4" disabled={submitting}>
                                        {submitting ? "Oluşturuluyor..." : t('create')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CreateCoupenMulti;
